@if(isLoading){
<div class="loading">
    <div class="loading_txt">
        <div class="load_txt">{{"startorderUk.loadinglabel" | cxTranslate}}</div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
</div>
}
<!--OM product selection page starts here -->


@if(productData && ((enablePage && enablePage.showAmendProductPage) || showAmendProductPage) && !showAmendDeliveryPage){
<div class="main no-pad OM_doseInput" id="contact_request" [ngClass]="seasonValue==prepreseason?'prepreamend':''">
    <!--OM product selection page body starts here -->
    <form #productData1="ngForm">
        @if(productData && productData.orderSummary.orderedandShippedProducts.orderedProducts &&
        productData.orderSummary.orderedandShippedProducts.orderedProducts.length > 0){
        <div class="prodSelectBody_container" id="OM_prodSelect">
            <!-- add soldout class in below div -->
            <div class="OM_contentHeader pb-3">
                <div class="col-xs-12 col-md-6 no-pad cart_neworderheader">
                    <span class="amendOrderHeader">Amend Your&nbsp;</span><span class="editseason">{{seasonValue |
                        seasonspilt}}</span><span class="amendOrderHeader2">&nbsp;
                        @if(prepreseason==seasonValue){Pre-order}
                        @else{
                        Order}</span>
                </div>

                <!-- <div class="OM_helpText">
                        Need help?<a class="OM_viewText" href="/OM-UserGuide-PDF" target="_blank">View the how-to guide here<img class="OM_viewArrow" alt="Previous screen" src="/_ui/responsive/theme-lambda/cms/assets/images/arrow-right.svg"></a>
                    </div> -->
            </div>
            @if(seasonValue!=prepreseason){
            <div class="no-pad amendcontentbox">
                <div class="col-md-6 no-pad">
                    <div class="OM_productTableHeader">{{"startorderUk.productpage.amendproduct" | cxTranslate}}</div>
                    <div class="OM_productTableSubHeader col-xs-11 no-pad prepretext">
           


                            <p>On flu360, you can order {{minproductdose}} doses and above per product per location with {{productData.priceResponse.SOR | number}}% Sale or Return and {{productData.priceResponse.creditDays}} days credit days.
                                
                            </p>
                            <div class="multipleoftext">{{producttext?.h2content}}
                            </div>
                           
                            

                    </div>
                   

                 
                    <div class="clearboth"></div>
                </div>
                <div class="col-md-6 prepreriskcontent">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                            d="M12.263 4.1138C12.3569 4.16778 12.4388 4.239 12.504 4.32338C12.5693 4.40776 12.6165 4.50366 12.6432 4.60558C12.6698 4.70751 12.6752 4.81347 12.6592 4.91742C12.6431 5.02136 12.6059 5.12125 12.5496 5.21139L8.3063 12.0001H23.6963L19.4513 5.21139C19.3377 5.02934 19.3041 4.81144 19.3578 4.6056C19.4116 4.39976 19.5483 4.22285 19.738 4.1138C19.9276 4.00474 20.1546 3.97247 20.369 4.02408C20.5834 4.07569 20.7677 4.20695 20.8813 4.38899L25.6396 12.0001H27.668C28.11 12.0001 28.5339 12.1687 28.8465 12.4688C29.159 12.7688 29.3346 13.1758 29.3346 13.6001V15.2001C29.3346 15.6244 29.159 16.0314 28.8465 16.3315C28.5339 16.6315 28.11 16.8001 27.668 16.8001V24C27.668 25.0609 27.229 26.0783 26.4476 26.8284C25.6662 27.5786 24.6064 28 23.5013 28H8.5013C7.39623 28 6.33643 27.5786 5.55502 26.8284C4.77362 26.0783 4.33464 25.0609 4.33464 24V16.8001C3.89261 16.8001 3.46868 16.6315 3.15612 16.3315C2.84356 16.0314 2.66797 15.6244 2.66797 15.2001V13.6001C2.66797 13.1758 2.84356 12.7688 3.15612 12.4688C3.46868 12.1687 3.89261 12.0001 4.33464 12.0001H6.36297L11.118 4.38899C11.1742 4.29884 11.2484 4.22021 11.3363 4.15758C11.4242 4.09496 11.5241 4.04957 11.6302 4.02402C11.7364 3.99846 11.8468 3.99324 11.9551 4.00864C12.0634 4.02405 12.1691 4.05978 12.263 4.1138ZM6.0013 16.8001V24C6.0013 24.6365 6.26469 25.247 6.73354 25.6971C7.20238 26.1472 7.83826 26.4 8.5013 26.4H23.5013C24.1643 26.4 24.8002 26.1472 25.2691 25.6971C25.7379 25.247 26.0013 24.6365 26.0013 24V16.8001H6.0013ZM4.33464 13.6001V15.2001H27.668V13.6001H4.33464ZM9.33464 18.4001C9.55565 18.4001 9.76761 18.4844 9.92389 18.6344C10.0802 18.7844 10.168 18.9879 10.168 19.2001V24C10.168 24.2122 10.0802 24.4157 9.92389 24.5657C9.76761 24.7157 9.55565 24.8 9.33464 24.8C9.11362 24.8 8.90166 24.7157 8.74538 24.5657C8.5891 24.4157 8.5013 24.2122 8.5013 24V19.2001C8.5013 18.9879 8.5891 18.7844 8.74538 18.6344C8.90166 18.4844 9.11362 18.4001 9.33464 18.4001ZM12.668 18.4001C12.889 18.4001 13.1009 18.4844 13.2572 18.6344C13.4135 18.7844 13.5013 18.9879 13.5013 19.2001V24C13.5013 24.2122 13.4135 24.4157 13.2572 24.5657C13.1009 24.7157 12.889 24.8 12.668 24.8C12.447 24.8 12.235 24.7157 12.0787 24.5657C11.9224 24.4157 11.8346 24.2122 11.8346 24V19.2001C11.8346 18.9879 11.9224 18.7844 12.0787 18.6344C12.235 18.4844 12.447 18.4001 12.668 18.4001ZM16.0013 18.4001C16.2223 18.4001 16.4343 18.4844 16.5906 18.6344C16.7468 18.7844 16.8346 18.9879 16.8346 19.2001V24C16.8346 24.2122 16.7468 24.4157 16.5906 24.5657C16.4343 24.7157 16.2223 24.8 16.0013 24.8C15.7803 24.8 15.5683 24.7157 15.412 24.5657C15.2558 24.4157 15.168 24.2122 15.168 24V19.2001C15.168 18.9879 15.2558 18.7844 15.412 18.6344C15.5683 18.4844 15.7803 18.4001 16.0013 18.4001ZM19.3346 18.4001C19.5556 18.4001 19.7676 18.4844 19.9239 18.6344C20.0802 18.7844 20.168 18.9879 20.168 19.2001V24C20.168 24.2122 20.0802 24.4157 19.9239 24.5657C19.7676 24.7157 19.5556 24.8 19.3346 24.8C19.1136 24.8 18.9017 24.7157 18.7454 24.5657C18.5891 24.4157 18.5013 24.2122 18.5013 24V19.2001C18.5013 18.9879 18.5891 18.7844 18.7454 18.6344C18.9017 18.4844 19.1136 18.4001 19.3346 18.4001ZM22.668 18.4001C22.889 18.4001 23.1009 18.4844 23.2572 18.6344C23.4135 18.7844 23.5013 18.9879 23.5013 19.2001V24C23.5013 24.2122 23.4135 24.4157 23.2572 24.5657C23.1009 24.7157 22.889 24.8 22.668 24.8C22.447 24.8 22.235 24.7157 22.0787 24.5657C21.9224 24.4157 21.8346 24.2122 21.8346 24V19.2001C21.8346 18.9879 21.9224 18.7844 22.0787 18.6344C22.235 18.4844 22.447 18.4001 22.668 18.4001Z"
                            fill="#2A3237" />
                    </svg>
                    <div [innerHtml]="producttext?.LargeText3"></div>
                </div>
            </div>
            }
            @if(seasonValue==prepreseason){
            <div class="no-pad amendcontentbox">
                <div class="col-md-6 no-pad">
                    <div class="OM_productTableHeader">Amend Selected Products</div>

                    <div class="multipleoftext">{{producttext?.h2content}}
                    </div>
                    <div class="OM_productTableSubHeader col-xs-11 no-pad prepretext">
                        <p>On flu360 you can pre-order&nbsp;{{minproductdose}} doses and above per product, per
                            location.
                        </p>

                    </div>


                    <div class="clearboth"></div>
                </div>
                <div class="col-md-6 prepreriskcontent">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                            d="M12.263 4.1138C12.3569 4.16778 12.4388 4.239 12.504 4.32338C12.5693 4.40776 12.6165 4.50366 12.6432 4.60558C12.6698 4.70751 12.6752 4.81347 12.6592 4.91742C12.6431 5.02136 12.6059 5.12125 12.5496 5.21139L8.3063 12.0001H23.6963L19.4513 5.21139C19.3377 5.02934 19.3041 4.81144 19.3578 4.6056C19.4116 4.39976 19.5483 4.22285 19.738 4.1138C19.9276 4.00474 20.1546 3.97247 20.369 4.02408C20.5834 4.07569 20.7677 4.20695 20.8813 4.38899L25.6396 12.0001H27.668C28.11 12.0001 28.5339 12.1687 28.8465 12.4688C29.159 12.7688 29.3346 13.1758 29.3346 13.6001V15.2001C29.3346 15.6244 29.159 16.0314 28.8465 16.3315C28.5339 16.6315 28.11 16.8001 27.668 16.8001V24C27.668 25.0609 27.229 26.0783 26.4476 26.8284C25.6662 27.5786 24.6064 28 23.5013 28H8.5013C7.39623 28 6.33643 27.5786 5.55502 26.8284C4.77362 26.0783 4.33464 25.0609 4.33464 24V16.8001C3.89261 16.8001 3.46868 16.6315 3.15612 16.3315C2.84356 16.0314 2.66797 15.6244 2.66797 15.2001V13.6001C2.66797 13.1758 2.84356 12.7688 3.15612 12.4688C3.46868 12.1687 3.89261 12.0001 4.33464 12.0001H6.36297L11.118 4.38899C11.1742 4.29884 11.2484 4.22021 11.3363 4.15758C11.4242 4.09496 11.5241 4.04957 11.6302 4.02402C11.7364 3.99846 11.8468 3.99324 11.9551 4.00864C12.0634 4.02405 12.1691 4.05978 12.263 4.1138ZM6.0013 16.8001V24C6.0013 24.6365 6.26469 25.247 6.73354 25.6971C7.20238 26.1472 7.83826 26.4 8.5013 26.4H23.5013C24.1643 26.4 24.8002 26.1472 25.2691 25.6971C25.7379 25.247 26.0013 24.6365 26.0013 24V16.8001H6.0013ZM4.33464 13.6001V15.2001H27.668V13.6001H4.33464ZM9.33464 18.4001C9.55565 18.4001 9.76761 18.4844 9.92389 18.6344C10.0802 18.7844 10.168 18.9879 10.168 19.2001V24C10.168 24.2122 10.0802 24.4157 9.92389 24.5657C9.76761 24.7157 9.55565 24.8 9.33464 24.8C9.11362 24.8 8.90166 24.7157 8.74538 24.5657C8.5891 24.4157 8.5013 24.2122 8.5013 24V19.2001C8.5013 18.9879 8.5891 18.7844 8.74538 18.6344C8.90166 18.4844 9.11362 18.4001 9.33464 18.4001ZM12.668 18.4001C12.889 18.4001 13.1009 18.4844 13.2572 18.6344C13.4135 18.7844 13.5013 18.9879 13.5013 19.2001V24C13.5013 24.2122 13.4135 24.4157 13.2572 24.5657C13.1009 24.7157 12.889 24.8 12.668 24.8C12.447 24.8 12.235 24.7157 12.0787 24.5657C11.9224 24.4157 11.8346 24.2122 11.8346 24V19.2001C11.8346 18.9879 11.9224 18.7844 12.0787 18.6344C12.235 18.4844 12.447 18.4001 12.668 18.4001ZM16.0013 18.4001C16.2223 18.4001 16.4343 18.4844 16.5906 18.6344C16.7468 18.7844 16.8346 18.9879 16.8346 19.2001V24C16.8346 24.2122 16.7468 24.4157 16.5906 24.5657C16.4343 24.7157 16.2223 24.8 16.0013 24.8C15.7803 24.8 15.5683 24.7157 15.412 24.5657C15.2558 24.4157 15.168 24.2122 15.168 24V19.2001C15.168 18.9879 15.2558 18.7844 15.412 18.6344C15.5683 18.4844 15.7803 18.4001 16.0013 18.4001ZM19.3346 18.4001C19.5556 18.4001 19.7676 18.4844 19.9239 18.6344C20.0802 18.7844 20.168 18.9879 20.168 19.2001V24C20.168 24.2122 20.0802 24.4157 19.9239 24.5657C19.7676 24.7157 19.5556 24.8 19.3346 24.8C19.1136 24.8 18.9017 24.7157 18.7454 24.5657C18.5891 24.4157 18.5013 24.2122 18.5013 24V19.2001C18.5013 18.9879 18.5891 18.7844 18.7454 18.6344C18.9017 18.4844 19.1136 18.4001 19.3346 18.4001ZM22.668 18.4001C22.889 18.4001 23.1009 18.4844 23.2572 18.6344C23.4135 18.7844 23.5013 18.9879 23.5013 19.2001V24C23.5013 24.2122 23.4135 24.4157 23.2572 24.5657C23.1009 24.7157 22.889 24.8 22.668 24.8C22.447 24.8 22.235 24.7157 22.0787 24.5657C21.9224 24.4157 21.8346 24.2122 21.8346 24V19.2001C21.8346 18.9879 21.9224 18.7844 22.0787 18.6344C22.235 18.4844 22.447 18.4001 22.668 18.4001Z"
                            fill="#2A3237" />
                    </svg>
                    <div [innerHtml]="producttext?.LargeText3"></div>
                </div>
                <!-- <div class="OM_productTableHeader">Risk Free Ordering</div>
                    <div class="OM_productTableSubHeader">Should new influenza policy guidance be issued that no
                        longer recommends either CSL Seqirus flu vaccines in their respective age group(s), you can
                        cancel that respective part of your order.</div> -->

            </div>
            }
            <div class="col-xs-12 col-md-12 no-pad OM_productContainer">
  @for(item of productData.productList;track item){
                <div class="col-xs-5 no-pad OM_productDetails">
                    <div class="OM_productBox" [ngClass]="!item.sellable ? 'disable_product' : ''">
                        @if(seasonValue === inseason){
                        <div class="prodSelect_img">
                            <!-- <img alt="aQIV" src="../../../assets/images/aQIV-GB-10-Mockup.png" style="width: 100%;"
                                *ngIf="item.baseName === 'AQIV'">
                                <img alt="aQIV" src="../../../assets/images/QIVc-GB-10-Mockup-2022-23.png" style="width: 93%;"
                                *ngIf="item.baseName === 'QIVC'"> -->
                                @if(item.baseName === 'AQIV'){
                            <img [alt]=productimage[0]?.media.altText [src]=getImage(productimage[0]?.media)
                                class="aqiv_Img" >
                                }
                                @if(item.baseName === 'QIVC'){
                            <img [alt]=productimage[1]?.media.altText [src]=getImage(productimage[1]?.media)
                                class="qivc_Img">
                                }
                        </div>
                        }
                        @if(seasonValue === preseason ){
                        <div class="prodSelect_img">
                            @if(item.baseName === 'Aujemflu'){
                            <img [alt]=productimage[2]?.media.altText [src]=getImage(productimage[2]?.media)
                                class="pre_Aqiv_Img">
                            }
                            @if(item.baseName === 'QIVC'){
                            <img [alt]=productimage[3]?.media.altText [src]=getImage(productimage[3]?.media)
                                class="pre_Qivc_Img">
                            }
                        </div>
                        }
                    </div>

                
                    <div [ngClass]="!item.sellable ? 'disable_product' : ''" class="productdescription col-xs-12">



                        <!-- <div class="OM_productTitle" ><span
                                *ngIf="item.baseName === 'AQIV'">Adjuvanted Trivalent Influenza Vaccine (aTIV)</span> <span *ngIf="item.baseName === 'QIVC'">Cell-Based Trivalent
                                Influenza
                                Vaccine
                                (TIVc)</span></div> -->
                        <!--  <div  class="OM_productSubTitle" [ngClass]="!item.sellable ? 'disable_product' : ''">(surface
                            antigen, inactivated) Seqirus</div> -->
                        <!--                    <div class="OM_descripsionText" [ngClass]="!item.sellable ? 'disable_product' : ''"><span
                                *ngIf="item.baseName === 'AQIV'">Licensed for people aged 50 years and above Recommended first line for 65+ Cohort</span>
                                <span *ngIf="item.baseName === 'QIVC'">Licensed for adults and children from 6 months of age Recommended first line for 18-64 at risk cohorts</span></div>
                                <div  class="alsorecommended"*ngIf="item.baseName === 'AQIV'">(Also recommended first line for 50-64 at risk cohorts)</div> -->
                        @if(item.baseName === 'AQIV' && seasonValue!=prepreseason){
                        <div [innerHtml]="producttext?.content"></div>
                        }
                        @if(item.baseName === 'Aujemflu' && seasonValue==preseason){
                            <div [innerHtml]="producttext?.largeparagraphcontent"></div>
                            }
                        @if(item.baseName === 'AQIV' && seasonValue==prepreseason){
                        <div [innerHtml]="producttext?.largeparagraphcontent"></div>
                        }
                        @if(item.baseName === 'QIVC' && seasonValue!=prepreseason){
                        <div [innerHtml]="producttext?.LargeText1"></div>
                        }
                        @if(item.baseName === 'QIVC' && seasonValue==prepreseason){
                        <div [innerHtml]="producttext?.paragraphcontent"></div>
                        }
                       <!--  @if(item.baseName === 'AQIV' && seasonValue!=prepreseason){
                        <span><span class="tooltipheader">{{producttext?.h3content}}</span><span
                                class="prodtooltip"><svg width="16" height="17" viewBox="0 0 16 17" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <mask id="mask0_1657_7057" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                        y="0" width="16" height="17">
                                        <rect y="0.420013" width="16" height="16" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_1657_7057)">
                                        <path
                                            d="M7.3335 11.7533H8.66683V7.75335H7.3335V11.7533ZM8.00016 6.42001C8.18905 6.42001 8.34738 6.35612 8.47516 6.22835C8.60294 6.10057 8.66683 5.94223 8.66683 5.75335C8.66683 5.56446 8.60294 5.40612 8.47516 5.27835C8.34738 5.15057 8.18905 5.08668 8.00016 5.08668C7.81127 5.08668 7.65294 5.15057 7.52516 5.27835C7.39738 5.40612 7.3335 5.56446 7.3335 5.75335C7.3335 5.94223 7.39738 6.10057 7.52516 6.22835C7.65294 6.35612 7.81127 6.42001 8.00016 6.42001ZM8.00016 15.0867C7.07794 15.0867 6.21127 14.9117 5.40016 14.5617C4.58905 14.2117 3.8835 13.7367 3.2835 13.1367C2.6835 12.5367 2.2085 11.8311 1.8585 11.02C1.5085 10.2089 1.3335 9.34223 1.3335 8.42001C1.3335 7.49779 1.5085 6.63112 1.8585 5.82001C2.2085 5.0089 2.6835 4.30335 3.2835 3.70335C3.8835 3.10335 4.58905 2.62835 5.40016 2.27835C6.21127 1.92835 7.07794 1.75335 8.00016 1.75335C8.92238 1.75335 9.78905 1.92835 10.6002 2.27835C11.4113 2.62835 12.1168 3.10335 12.7168 3.70335C13.3168 4.30335 13.7918 5.0089 14.1418 5.82001C14.4918 6.63112 14.6668 7.49779 14.6668 8.42001C14.6668 9.34223 14.4918 10.2089 14.1418 11.02C13.7918 11.8311 13.3168 12.5367 12.7168 13.1367C12.1168 13.7367 11.4113 14.2117 10.6002 14.5617C9.78905 14.9117 8.92238 15.0867 8.00016 15.0867ZM8.00016 13.7533C9.48905 13.7533 10.7502 13.2367 11.7835 12.2033C12.8168 11.17 13.3335 9.9089 13.3335 8.42001C13.3335 6.93112 12.8168 5.67001 11.7835 4.63668C10.7502 3.60335 9.48905 3.08668 8.00016 3.08668C6.51127 3.08668 5.25016 3.60335 4.21683 4.63668C3.1835 5.67001 2.66683 6.93112 2.66683 8.42001C2.66683 9.9089 3.1835 11.17 4.21683 12.2033C5.25016 13.2367 6.51127 13.7533 8.00016 13.7533Z"
                                            fill="var(--lightgrey)" />
                                    </g>
                                </svg><span class="tooltiptext"
                                    [innerHtml]="producttext?.LargeText2"></span></span></span>} -->

                        <div class="prefilled" [ngClass]="!item.sellable ? 'disable_product' : ''">
                            {{"startorderUk.productpage.needlepresentxt" | cxTranslate}}</div>
                    </div>
                    <!-- preseason ends -->
                </div>
            }
                <!-- <div class="col-xs-12 col-md-4 no-pad OM_productDetails" id="qivc">
                <div class="OM_productBox"></div>
                <div class="OM_productTitle">Cell-Based Quadrivalent Influenza Vaccine (QIVc)</div>
                <div class="OM_productSubTitle">(surface antigen, inactivated) Seqirus</div>
                <div class="OM_descripsionText">For adults and children from 2 years of age</div>
                <div class="OM_productCost">
                    <div>10-pack</div>
                    <div class="OM_verticlDivision"></div>
                    <div class="priceDetail">&#163;<span>10.00</span> per dose</div>
                </div>
            </div> -->
            </div>
            <div class="clearboth"></div>


            <section class="col-xs-12 OM_productDoseSection no-padding">
                <!-- Table starts -->
                <div class="locationrowall col-md-12 locationrow60149134 no-pad prebook_product">
                    <div class="tableContainer">
                        <div>
                            <div class="OM_productLocation prebookprodlocation col-xs-12" id="prodLocation1">

                                <div class="col-xs-12  OM_locParent">
                                    
                                    <div class="col-xs-12 col-md-12 OM_locationText pl-2 pr-0">
                                        {{productData.orderSummary.delLocation}}
                                        <!-- <div class="zipcodewrap"> GB HP18 9SA</div> -->
                                    </div>
                                </div>
                                <div class="col-xs-12 col-md-12 prodcontbox no-padding">
                                @for(productList of productData.orderSummary.orderedandShippedProducts.orderedProducts;track productList; let j=$index){
                                <div class="amendproductbox"
                                    >
                                    <div class="col-xs-12 allProd no-padding">
                                        <div class="col-xs-12 productheader">

                                            <div class="">
                                                @if(productList.baseProdName === 'aTIV 10 Pack' || productList.baseProdName === 'Aujemflu 10 Pack' ){
                                                <div class="OM_locationProdName">
                                                    @if(productList.baseProdName === 'aTIV 10 Pack'){
                                                    aTIV
                                                    }
                                                    @if(productList.baseProdName === 'Aujemflu 10 Pack'){
                                                        Aujemflu
                                                    }
                    
                                                    @if(seasonValue==prepreseason){
                                                    <span>(aIIV)</span>
                                                    }
                                                    @if(seasonValue==preseason){
                                                        <span>(aIIVc)</span>
                                                        }

                                                </div>
                                                }
                                                @if(productList.baseProdName === 'TIVc 10 Pack'){
                                                <div class="OM_locationProdName"
                                                    >TIVc
                                                    
                                                    @if(seasonValue!=inseason){
                                                        <span
                                                        >(IIVc)</span>
                                                    }
                                                    </div>
                                                }
                                                @if(productData.productList[j].baseProductName === 'aTIV - 10 Pack' || productData.productList[j].baseProductName === 'Aujemflu - 10 Pack'){
                                                <div class="OM_prodDes">
                                                    @if(seasonValue==prepreseason){
                                                    <div>{{productData?.productList[j].perPack}} Pack</div>
                                                    }
                                                
                                                @if(seasonValue==preseason){

                                                    <div>{{producttext?.solutiontype}}</div>
                                                        <!-- <div>{{productList.perPack}} Pack</div>
                                                        <div class="OM_verticlDivision"></div> -->
                                                        <div class="priceDetail">Customer Price 
                                                            &#163;<span>{{productData?.productList[j].priceData?.value |
                                                                number:'1.2'}}</span>  (ex VAT)</div>
                                                  
                                                        }@else if(seasonValue==inseason){
                                                            <div>{{producttext?.paragraphcontent}}</div>
                                                        <!-- <div>{{productList.perPack}} Pack</div>
                                                        <div class="OM_verticlDivision"></div> -->
                                                        <div class="priceDetail">Customer Price 
                                                            &#163;<span>{{productData?.productList[j].priceData?.value |
                                                                number:'1.2'}}</span>  (ex VAT)</div>
                                                        }
                                                </div>
                                            }
                                            @if(productData.productList[j].baseProductName === 'TIVc - 10 Pack'){
                                                <div class="OM_prodDes">
                                                    @if(seasonValue==prepreseason){
                                                    <div>{{productData?.productList[j].perPack}} Pack</div>
                                                    }
                                                   
                                                    @if(seasonValue!=prepreseason){
                                                        <div>{{producttext?.paragraphcontent}}</div>
                                                    <div class="priceDetail">Customer Price 
                                                        &#163;<span>{{productData.productList[j].priceData.value |
                                                            number:'1.2'}}</span> per dose</div>
                                                        }
                                                </div>
                                            }
                                                <!-- year data without backet for provisional order -->
                                            </div>
                                            <!-- <div class="col-md-6">
                                <div class="OM_locationProdName">QIVc 10 Pack</div>
                                <div class="OM_prodDes">(6 months &amp; above)</div>
                            </div> -->

                                        </div>
                                        <div class="col-xs-12 prodincontainer">

                                            <div class="col-xs-12 aqivcontainer createproductsize">


                                                <div class="doseQuant aqivinputcont" class="prodin_Aqiv_Input_Cont"
                                                    [ngClass]="productList.errorMsg ? 'has-error' : ''">
                                                    @if((productData.orderSummary.status == 'Order Pending Approval' || productData.orderSummary.status == 'Amendment Pending Approval') && seasonValue==prepreseason){
                                                    <input
                                                        
                                                        id="{{j}}" name="{{j}}" placeholder="0"
                                                        class="form-control aqiv_box dynDoseInput dynplacecolor"
                                                        type="text" value="" autocomplete="no" #productValue
                                                        [ngModel]="productList.quantityInDoses"
                                                        (ngModelChange)="handleOnProdValueChange($event,j,'preprequantityInDoses')"
                                                        (keyup)="handlenan($event)">
                                                    }
                                                    @if(productData.orderSummary.status == 'Order Pending Approval' || productData.orderSummary.status == 'Amendment Pending Approval'){
                                                        <input
                                                            
                                                            id="{{j}}" name="{{j}}" placeholder="0"
                                                            class="form-control aqiv_box dynDoseInput dynplacecolor"
                                                            type="text" value="" autocomplete="no" #productValue
                                                            [ngModel]="productList.quantityInDoses"
                                                            (ngModelChange)="handleOnProdValueChange($event,j,'quantityInDoses')"
                                                            (keyup)="handlenan($event)">
                                                        }
                                                    @if(productData.orderSummary.status != 'Order Pending Approval' && productData.orderSummary.status != 'Amendment Pending Approval' && seasonValue!=prepreseason){
                                                    <input
                                                        
                                                        id="{{j}}" name="{{j}}" placeholder="0"
                                                        class="form-control aqiv_box dynDoseInput dynplacecolor"
                                                        type="text" value="" autocomplete="no" #productValue
                                                        [ngModel]="productList.quantityInDoses"
                                                        (ngModelChange)="handleOnProdValueChange($event,j,'confirmedQty')"
                                                        (keyup)="handlenan($event)">
                                                    }
                                                    @if(productList.errorMsg){
                                                    <span
                                                        class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                                        ></span>
                                                    }
                                                    <div class="totaldose pt-0 pl-1">
                                                        {{"startorderUk.productpage.totaldoses" | cxTranslate}}</div>
                                                </div>
                                               @if(seasonValue!=prepreseason){
                                                @if(!productList.errorMsg.includes("Decrease order") && productList.baseProdName == 'Aujemflu 10 Pack' && confirmwithzeroaqiv==false){
                                                    <div class="doseValidationText pb-2"
                                                        >
                                                        Decrease order by up to {{productData.amendOrderConstraintList.aqivPercentageAmendOrder}}% only
                                                        <!-- You can increase up to {{aqivtotal Value | number}} --></div>
                                                }
                                                @if(!productList.errorMsg.includes("Decrease order") && productList.baseProdName == 'TIVc 10 Pack' && confirmwithzeroqivc==false){
                                                    <div class="doseValidationText pb-2">
                                                        Decrease order by up to {{productData.amendOrderConstraintList.qivcPercentageAmendOrder}}% only
                                                        <!-- You can increase up to {{qivctotalValue | number}} --></div>
                                                }
                                                @if(!productList.errorMsg && productList.baseProdName == 'Aujemflu 10 Pack' && confirmwithzeroaqiv==true ){
                                                    <div class="doseValidationText pb-2">
                                                        You can enter 
                                                        @if(MaxQuantityCheckEnabled==1){
                                                                {{minproductdose}}
                                                            - {{maxproductwithcomma}}
                                                        }@else{
                                                          at least
                                                            {{minproductdose}}
                                                         } doses</div>
                                                }
                                                @if(!productList.errorMsg && productList.baseProdName == 'TIVc 10 Pack' && confirmwithzeroqivc==true){
                                                    <div class="doseValidationText pb-2">
                                                        You can enter 
                                                        @if(MaxQuantityCheckEnabled==1){
                                                            {{minproductdose}}
                                                            - {{maxproductwithcomma}}
                                                        }@else{
                                                            at least
                                                            {{minproductdose}}
                                                        } doses</div>
                                                }
                                                }
                                                @if(productList.errorMsg){
                                                <label  id="{{j}}"
                                                    class="error help-block prod_Help_Block"
                                                    for="{{j}}">{{productList.errorMsg}}</label>
                                                }

                                            </div>
                                            <!-- <div class="col-xs-12 col-md-6 aqivcontainer createproductsize pl-0">
                                <div class="doseQuant aqivinputcont pl-3">
                                    <input id="cdose[0]"
                                        name="createOrderData[0].CreateOrderProductData[1].productQuantity"
                                        placeholder="0" class="form-control qivc_box dynDoseInput onlyQivc" type="text"
                                        value="" autocomplete="no"><input
                                        id="createOrderData0.CreateOrderProductData1.productCode"
                                        name="createOrderData[0].CreateOrderProductData[1].productCode" value="10054364"
                                        type="hidden">
                                    <div class="totaldose">
                                        Total Doses</div>

                                </div>

                            </div> -->
                                        </div>
                                    </div>

                                </div>
                                }
                                <div class="col-xs-12  totalcost col-xs-12 aqivcontainer createproductsize pr-0">
                                    <div  class="doseQuant aqivinputcont pr-0 pl-0 aqiv_Input_Cont">
                                       
                                    <input id="totalcode" name="totalcost" placeholder="0"
                                                        readonly  [value]="productData.orderSummary.totalCost | currency:'GBP':'symbol':'1.2-2'"
                                                        class="form-control totalcostinput aqiv_box dynDoseInput dynplacecolor"
                                                        type="text"  autocomplete="no" 
                                                      >
                                                      <div class="totaldose pt-0 pl-1">
                                                        Total Cost (ex VAT)
                                                    </div>
                                                </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Table Ends -->
                <!--    <button id="popid" class="OM_removedosesBtn" *ngIf="productData.orderSummary.status == 'Order Pending Approval'" data-bs-toggle="modal" data-bs-target="#cart_removemodal"
                >
                {{"startorderUk.productpage.removealldoses" | cxTranslate}}</button> -->
            </section>
            <div class="col-xs-12 OM_tableBottomBtn">
           
           
                <a class="OM_exitBtn showPopupclick"  (click)="handleOnExitClick()"
                    data-toggle="modal" data-target="#OM_exitPopup">{{"startorderUk.productpage.exitlabel" |
                    cxTranslate}}</a>
            
                <div class="OM_rightBtnParent pr-0"
                    [ngClass]="seasonValue==prepreseason?'amendprepr':''">
                    <button class="OM_selectWeekBtn" [disabled]="disableDeliveryBtn"
                        (click)="handleOnDeliveryBtnClick()">{{"startorderUk.productpage.amenddeliveryweek" |
                        cxTranslate}}</button>
                </div>
            </div>
            @if(seasonValue==prepreseason){
            <div  class="prodlasttext">{{producttext?.text4}}</div>
            }

            <div class="clearboth"></div>
        </div>
        }
    </form>
    <!--OM product selection page body ends here -->

    <!-- external Popup starts -->
    <div class="OM_externalPop modal" data-backdrop="static" id="OM_externalPop">
        <div class="OM_externalPopContent">
            <div class="OM_externalPopHeader">
                <div class="OM_externalPopTitle">{{"startorderUk.exitpopup.title" | cxTranslate}}</div>
                <div class="OM_externalPopClose">X</div>
                <div class="clearboth"></div>
            </div>
            <div class="OM_externalPopText">
                <p>{{"startorderUk.exitpopup.message" | cxTranslate}}</p>
            </div>
            <div class="OM_externalPopBtns">
                <button class="OM_externalPopBtn OM_externalPopBackBtn">{{"startorderUk.exitpopup.gobacklabel" |
                    cxTranslate}}</button>
                <button class="OM_externalPopBtn OM_externalPopExitBtn">{{"startorderUk.exitpopup.exitnloselabel" |
                    cxTranslate}}</button>
            </div>
        </div>
    </div>
    <!-- external Popup ends -->

</div>
}

<!-- amend delivery week start here -->
 @if(showAmendDeliveryPage){
<div class="editdelivery">
    <section class=" col-xs-12 OM_productDetailsSection">
        <div class="col-xs-6 cart_neworderheader">Amend Your&nbsp;<span class="editseason">{{seasonValue |
                seasonspilt}}</span>&nbsp;@if(
               prepreseason==seasonValue){Pre-order}@else{Order}</div>
    </section>

    <section id="Editdeliverpage" class="col-xs-12" data-gtm-vis-recent-on-screen41137814_331="7747"
        data-gtm-vis-first-on-screen41137814_331="7747" data-gtm-vis-total-visible-time41137814_331="100"
        data-gtm-vis-has-fired41137814_331="1">
        <div class="deliverycontainer editDeliverySlots" id="editDeliveryslotJSPPage">


            <div class="deliverybox">
                <div>
                    <!-- provisional changes -->
                    <div class="orders_backText" (click)="handleOnBackToProductBtnClick()">
                        <div class="global_blackarrow"></div>
                        @if(seasonValue!=prepreseason){
                        <span>{{"startorderUk.deliveryweek.backtoamendproduct" |
                            cxTranslate}}</span>
                        }
                        @if(seasonValue==prepreseason){
                            <span>Back to Product Selection</span>
                        }
                    </div>
                </div>
                <div class="greyline"></div>
                <!-- the line code -->
                <div class="delivery_textContainer">
                    <div class="deliveryheader">{{producttext?.text1}}</div>
                    <div class="deliveytext">{{producttext?.text2}}</div>
                    <ul class="deliveytext">
                        <li class="deliverylist">
                            {{editdeliverydata?.deliverySlotConstraintList?.firstNumberOfDelSlots}}&nbsp;delivery
                            permitted in the
                            first&nbsp;{{editdeliverydata?.deliverySlotConstraintList?.maxDeliverySlots}}
                            weeks</li>
                            @if(seasonValue != prepreseason){
                        <li class="deliverylist">{{mindeliveryslot}} 
                            @if(MaxQuantityCheckEnabled==1){
                            <span
                                class="editdelMaxSlot">- {{maxdeliveryslotwithcomma}}
                                doses</span>
                            }
                            @if(MaxQuantityCheckEnabled==0){<span> doses minimum</span>} permitted per
                            selected slot</li>
                        }
                       <!--  @if(seasonValue != prepreseason){
                        <li class="deliverylist">
                            {{"startorderUk.deliveryweek.deliveryslotmsg" | cxTranslate}}</li>
                        } -->
                    </ul>
                 
                    
                    <div class="deliveytext margin-B30">
                        {{producttext?.materialSubHeading}}</div>
                    

                    <div class="atcap_box">
                        <!-- capacity circle code -->
                        <div class="capacity_circle"></div>
                        <div class="capacity_text">{{"startorderUk.deliveryweek.fullbooked" | cxTranslate}}</div>
                        <div class="middlespace"></div>
                        <div class="Unavaible"></div>
                        <div class="capacity_text">{{"startorderUk.productpage.unavailabletxt" | cxTranslate}}</div>
                       
                            <div class="middlespace"></div>
                            <div class="avaiablecircle"></div>
                            <div class="capacity_text">Available</div>
                        
                    </div>
                </div>
               

                <div id="editDeliveryparent">
                    <form #weekselectionform="ngForm">

                        <!-- location container start from here -->
                        <!-- this code will run in loop to get multiple location -->
                        <div class="deliveylocation">
                            <div class="greyline"></div>
                            <!-- the line code -->
                            <!-- Edit location details -->
                            <!-- Edit delivery weeks -->
                            <div class="row">
                                <div class="seasonvalue no-padding">{{deliveryseason}} Delivery Dates</div>
                                <div class="no-padding deliveyweek">(week commencing)</div>


                            </div>

                            <div class="row">
                                <div class="col-xs-1 deliverycol locationtext margin-B20 margin-T20">
                                    Location&nbsp;<span
                                        class="deliverylocno">{{editdeliverydata.deliverySlotResponseData.shippingLocations.length}}</span>
                                </div>
                                <div class="col-xs-1 deliverycol1 dashsymbol margin-B20 margin-T20">|</div>
                                <div class="col-xs-11  deliverycol2 locationdetail margin-B20 margin-T20">
                                    {{editdeliverydata.orderSummary.delLocation}}</div>
                            </div>

                            <!-- prepreseason changes -->

             

                            <div class="row">
                                <div class="col-xs-12 no-padding">
                                    <input type="hidden" id="weeknumber" value="9">
                                    <table class="deliverytable">
                                        <tbody>
                        
                                           
                                            <!-- aqiv week start -->

                                            <!-- product week start -->
                                            @for( product of editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials;track product;let k=$index){
                                                <!-- aqiv or first product depend the the productlist sequence -->
                                                @if(product.materialID==editdeliverydata.productList[0].code){
                                                    <tr>
                                                        @if(editdeliverydata.productList[0].baseProductName=='aTIV - 10 Pack'){
                                                            <td class="productheader" [attr.colspan]="editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials[0].deliverySlots?.length">
                                                              
                                                                {{"startorderUk.deliveryweek.ativ" | cxTranslate}}
                                                              
                                                                <span> (aIIV)</span>
                                                                <div class="middletext"><span
                                                                    class="tenpack">{{"startorderUk.deliveryweek.10packlabel"
                                                                    | cxTranslate}}</span>
                                                                <br><span class="prepreyear">(50+ years)</span></div>
                                                                
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            }
                                                            @else{
                                                                <td class="productheader" [attr.colspan]="editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials[0].deliverySlots?.length">
                                                                Aujemflu (aIIVc) <span class="tenitem"> {{"startorderUk.deliveryweek.10packlabel"
                                                                    | cxTranslate}}</span>
                                                                    <div class="middletext middletextnew"><div class="listprice">{{producttext?.solutiontype}}</div>
                                                                   
                                                                    <div class="priceDetail">Customer Price &#163;<span>{{editdeliverydata?.productList[0]?.priceData?.value
                                                                        | number:'1.2' }}</span>  (ex VAT)</div></div>
                                                                </td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            }

                                                  
                                                    </tr>
                                                    <tr id="month">
                                                        <!-- <td class="delivery_date deliverycol">Delivery Date*</td> -->
                                                       <!--  <td class="deliverycol1"></td> -->
                                                        @for(
                                                           deliverydate of editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials[0].deliverySlots;track deliverydate; let d=$index){
                                                            @if(d!=(editdeliverydata.deliverySlotConstraintList.maxDeliverySlots)){
                                                                <td class=" datetext">{{deliverydate.month}}</td>
                                                            }
                                                            @if(d==(editdeliverydata.deliverySlotConstraintList.maxDeliverySlots)){
                                                                <td class="gapbet"></td>
                                                                <td class=" datetext">{{deliverydate.month}}</td>
                                                            }
        
                                                           }
        
                                                        <td class="gapdose"></td>
                                                        <td class="dosestext ">Doses</td>
                                                        <td class=" dosestext">Doses</td>
                                                        <!-- <td class="greentick"></td> -->
                                                    </tr>
                                                    <tr class="">
                                                        <!-- <td class="deliveyweek deliverycol">{{"startorderUk.weekcommencingtxt" |
                                                            cxTranslate}}</td> -->
                                                       <!--  <td class="deliverycol1"></td> -->
        
                                                        @for( deliverydate of editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials[0].deliverySlots;track deliverydate;let d=$index){
                                                            @if(d!=editdeliverydata.deliverySlotConstraintList.maxDeliverySlots){
                                                                <td class=" datetext">{{deliverydate.date}}</td>
                                                            }@else{
                                                            
                                                                <td class="gapbet"></td>
                                                                <td class=" datetext">{{deliverydate.date}}</td>
                                                            }
        
                                                        }
                                                        <td class="gapdose"></td>
                                                        <td class="dosestext ">{{"startorderUk.deliveryweek.scheduled" |
                                                            cxTranslate}}</td>
                                                        <td class=" dosestext">{{"startorderUk.deliveryweek.ordered" |
                                                            cxTranslate}}</td>
                                                        <!-- <td class="greentick"></td> -->
                                                    </tr>
                                                    <tr id="delivey_aQIV">

                                                      


                                                        <!-- <td class="deliverycol1"></td> -->

                                                        <ng-container
                                                            *ngFor="let productinput1 of product.deliverySlots;let j=index">
                                                            @if(j < editdeliverydata.deliverySlotConstraintList.maxDeliverySlots){
                                                                <td class="deliverydate_input"
                                                                    [ngClass]="productinput1?.producterrorMsg ? 'has-error' : ''">
                                                                    <input type="text"
                                                                        [ngClass]="productinput1.available=='N'?'at_capacity':''"
                                                                        [disabled]="productinput1.available=='N' || productinput1?.disablerule==true"
                                                                        [(ngModel)]="productinput1.quantity"
                                                                        (ngModelChange)="amendhandleOndeliveryValueChange($event,j,k)"
                                                                        autocomplete="off"
                                                                        (keyup)="handledelvierynanbuusiiness($event,j,k,editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials.length)"
                                                                        class="delivery_data  aqivcount form-control dynvacinedoses"
                                                                        id="aqivfirst[0][{{j}}]"
                                                                        name="createOrderData[0].createOrderProductData[0].createOrderDeliverySlotData[{{j}}]].quantity" /><span
                                                                        class="glyphicon form-control-erroricon"
                                                                        [ngClass]="productinput1?.producterrorMsg ? 'glyphicon-exclamation-sign' : ''"></span>
                                                                </td>
                                                            }
                                                            @else{
                                                                <td class="gapbet"
                                                                    *ngIf="j == editdeliverydata.deliverySlotConstraintList.maxDeliverySlots">
                                                                </td>
                                                                <td class="deliverydate_input"
                                                                    [ngClass]="productinput1?.producterrorMsg ? 'has-error' : ''">
                                                                    <input type="text"
                                                                        [ngClass]="productinput1.available=='N'?'at_capacity':''"
                                                                        [disabled]="productinput1.available=='N'"
                                                                        autocomplete="off"
                                                                        (ngModelChange)="amendhandleOndeliveryValueChange($event,j,k)"
                                                                        [(ngModel)]="productinput1.quantity"
                                                                        class="delivery_data  aqivcount form-control dynvacinedoses"
                                                                        id="aqivfirst[0][{{j}}]"
                                                                        name="createOrderData[0].createOrderProductData[0].createOrderDeliverySlotData[{{j}}]].quantity"
                                                                        (keyup)="handledelvierynan($event,j,k)" /><span
                                                                        class="glyphicon form-control-erroricon"
                                                                        [ngClass]="productinput1?.producterrorMsg ? 'glyphicon-exclamation-sign' : ''"></span>
                                                                </td>
                                                            }

                                                        </ng-container>

                                                        <td class="gapdose"></td>
                                                        <td class="deliveryallocated_input dosesbox"
                                                            [ngClass]="product?.allocatederrorMsg ? 'has-error' : ''">
                                                            <input type="text" autocomplete="off"
                                                                class=" delivery_data aqiv_allocated form-control dynallacted"
                                                                id="aqivallocated[0]"
                                                                [(ngModel)]="product.allocatedvalue"
                                                                name="deliveryweek.aqivallocated[0]" readonly
                                                                value="" /><span
                                                                class="glyphicon form-control-erroricon"
                                                                [ngClass]="product?.allocatederrorMsg ? 'glyphicon-exclamation-sign' : ''"></span>
                                                        </td>
                                                        <td class="deliverydate_input dosesbox "><input type="text"
                                                                autocomplete="off"
                                                                class=" delivery_data aqivtotal form-control "
                                                                id="aqivtotal[0]"
                                                                [value]="numberWithCommas(product.qty)" readonly /></td>
                                                       <!--  <td class="greentick"
                                                            [ngClass]="product?.matchtick? 'matchtick':''">
                                                        </td> -->
                                                    </tr>
                                                    <tr class="aqivyear">
                                                                       
       
                                                        <!-- <td class="deliverycol1"></td> -->
                                                        <td [attr.colspan]="editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials[0].deliverySlots?.length" class="errorarea">
                                                            @if(editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials.length!=2){
                                                                <!-- error handle if only aqiv -->
                                                                 @if(editdeliverydata.deliverySlotResponseData.shippingLocations[0]?.locationsumerror){
                                                                <div class="totalcheck">
                                                                    {{"startorderUk.deliveryweek.doseserrormsg" |
                                                                    cxTranslate}}</div>
                                                                 }
                                                                <div class="allocatedcheck">
                                                                    @if(editdeliverydata.deliverySlotResponseData.shippingLocations[0]?.locationlevelerror){
                                                                    {{editdeliverydata.deliverySlotResponseData.shippingLocations[0]?.locationmsg}}
                                                                }
                                                                </div>
                                                                <!-- <div class="allocatedcheck">Please enter a volume to the nearest unit of 10</div> -->
                                                            }

                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td class="totalvat">
                                                            Total (ex VAT)
        
                                                        </td>
                                                        <td class="totalcostdelivery">
                                                            <input autocomplete="off"
                                                                class=" delivery_data aqivtotal form-control " name="deliveryweek.aqivtotalcost"
                                                                id="aqivtotalcost" [(ngModel)]="product.totalcosteach" value=""
                                                                readonly />
        
                                                        </td>


                                                    </tr>

                                                }
                                               @if(product.materialID==editdeliverydata.productList[1].code){
                                                <tr>
                                                    @if(editdeliverydata.productList[1].baseProductName=='TIVc - 10 Pack'){
                                                        @if(editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials.length>1){
                                                        <td class="productheader " [attr.colspan]="editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials[1].deliverySlots?.length">
                                                            {{"startorderUk.deliveryweek.tivc" | cxTranslate}}
                                                            <span> (IIVc)</span>@if(seasonValue==prepreseason){
                                                                <span class="tenitem"> {{"startorderUk.deliveryweek.10packlabel"
                                                                    | cxTranslate}}</span>
                                                                    <div class="middletext">
                                                                        <span class="tenpack float_left">
                                                                            <span
                                                                                class="float_left">{{"startorderUk.deliveryweek.10packlabel"
                                                                                | cxTranslate}} </span>
                                                                            <br>
                                                                            <span
                                                                                class="prepreyear">{{"startorderUk.deliveryweek.18to64yearslabel"
                                                                                | cxTranslate}}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                            }@else{
                                                                <span class="tenitem"> {{"startorderUk.deliveryweek.10packlabel"
                                                                    | cxTranslate}}</span>
                                                                <div class="middletext  middletextnew"><div class="listprice">{{producttext?.paragraphcontent}}</div>        
                                                                   
                                                                <div class="priceDetail">Customer Price &#163;<span>{{editdeliverydata?.productList[1]?.priceData?.value
                                                                    | number:'1.2' }}</span>  (ex VAT)</div></div>
                                                            }
                                                           
                                                        </td>
                                                        }@else{
                                                            <td class="productheader " [attr.colspan]="editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials[0].deliverySlots?.length">
                                                                {{"startorderUk.deliveryweek.tivc" | cxTranslate}}
                                                                <span> (IIVc)</span>@if(seasonValue==prepreseason){
                                                                    <span class="tenitem"> {{"startorderUk.deliveryweek.10packlabel"
                                                                        | cxTranslate}}</span>
                                                                        <div class="middletext">
                                                                            <span class="tenpack float_left">
                                                                                <span
                                                                                    class="float_left">{{"startorderUk.deliveryweek.10packlabel"
                                                                                    | cxTranslate}} </span>
                                                                                <br>
                                                                                <span
                                                                                    class="prepreyear">{{"startorderUk.deliveryweek.18to64yearslabel"
                                                                                    | cxTranslate}}
                                                                                </span>
                                                                            </span>
                                                                        </div>
                                                                }@else{
                                                                    <span class="tenitem"> {{"startorderUk.deliveryweek.10packlabel"
                                                                        | cxTranslate}}</span>
                                                                    <div class="middletext  middletextnew"><div class="listprice">{{producttext?.paragraphcontent}}</div>        
                                                                       
                                                                    <div class="priceDetail">Customer Price &#163;<span>{{editdeliverydata?.productList[1]?.priceData?.value
                                                                        | number:'1.2' }}</span>  (ex VAT)</div></div>
                                                                }
                                                               
                                                            </td>

                                                        }
                                                           
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                   
                                                            }
                                                         
                                                            


                                                           





                                                </tr>
                                                <tr id="month">
                                                    <!-- <td class="delivery_date deliverycol">Delivery Date*</td> -->
                                                   <!--  <td class="deliverycol1"></td> -->
                                                    @for(
                                                       deliverydate of editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials[0].deliverySlots;track deliverydate; let d=$index){
                                                        @if(d!=(editdeliverydata.deliverySlotConstraintList.maxDeliverySlots)){
                                                            <td class=" datetext">{{deliverydate.month}}</td>
                                                        }
                                                        @if(d==(editdeliverydata.deliverySlotConstraintList.maxDeliverySlots)){
                                                            <td class="gapbet"></td>
                                                            <td class=" datetext">{{deliverydate.month}}</td>
                                                        }
    
                                                       }
    
                                                    <td class="gapdose"></td>
                                                    <td class="dosestext ">Doses</td>
                                                    <td class=" dosestext">Doses</td>
                                                    <!-- <td class="greentick"></td> -->
                                                </tr>
                                                <tr class="">
                                                    <!-- <td class="deliveyweek deliverycol">{{"startorderUk.weekcommencingtxt" |
                                                        cxTranslate}}</td> -->
                                                   <!--  <td class="deliverycol1"></td> -->
    
                                                    @for( deliverydate of editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials[0].deliverySlots;track deliverydate;let d=$index){
                                                        @if(d!=editdeliverydata.deliverySlotConstraintList.maxDeliverySlots){
                                                            <td class=" datetext">{{deliverydate.date}}</td>
                                                        }@else{
                                                        
                                                            <td class="gapbet"></td>
                                                            <td class=" datetext">{{deliverydate.date}}</td>
                                                        }
    
                                                    }
                                                    <td class="gapdose"></td>
                                                    <td class="dosestext ">{{"startorderUk.deliveryweek.scheduled" |
                                                        cxTranslate}}</td>
                                                    <td class=" dosestext">{{"startorderUk.deliveryweek.ordered" |
                                                        cxTranslate}}</td>
                                                    <!-- <td class="greentick"></td> -->
                                                </tr>
                                                    <tr id="delivey_QIVc">

                                    
                                                      
                                                       <!--  <td class="deliverycol1"></td> -->
                                                        <ng-container
                                                            *ngFor="let productinput2 of product.deliverySlots;let j=index">
                                                            @if(j<editdeliverydata.deliverySlotConstraintList.maxDeliverySlots){
                                                                <td class="deliverydate_input"
                                                                    [ngClass]="productinput2.producterrorMsg ? 'has-error' : ''">
                                                                    <input type="text"
                                                                        [ngClass]="productinput2.available=='N'?'at_capacity':''"
                                                                        [disabled]="productinput2.available=='N' || productinput2.disablerule==true"
                                                                        autocomplete="off"
                                                                        class="delivery_data qivccount  form-control dynvacinedoses"
                                                                        id="qivcfirst[0][{{j}}]"
                                                                        [(ngModel)]="productinput2.quantity"
                                                                        (keyup)="handledelvierynanbuusiiness($event,j,k,editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials.length)"
                                                                        (ngModelChange)="amendhandleOndeliveryValueChange($event,j,k)"
                                                                        name="createOrderData[0].createOrderProductData[1].createOrderDeliverySlotData[{{j}}].quantity" /><span
                                                                        class="glyphicon form-control-erroricon"
                                                                        [ngClass]="productinput2.producterrorMsg ? 'glyphicon-exclamation-sign' : ''"></span>
                                                                </td>
                                                            }
                                                            @else{
                                                                @if(j==editdeliverydata.deliverySlotConstraintList.maxDeliverySlots){
                                                                <td class="gapbet">
                                                                </td>
                                                            }
                                                                <td class="deliverydate_input"
                                                                    [ngClass]="productinput2.producterrorMsg ? 'has-error' : ''">
                                                                    <input type="text"
                                                                        [ngClass]="productinput2.available=='N'?'at_capacity':''"
                                                                        [disabled]="productinput2.available=='N'"
                                                                        autocomplete="off"
                                                                        (ngModelChange)="amendhandleOndeliveryValueChange($event,j,k)"
                                                                        class="delivery_data qivccount form-control dynvacinedoses"
                                                                        id="qivcfirst[0][{{j}}]"
                                                                        [(ngModel)]="productinput2.quantity"
                                                                        name="createOrderData[0].createOrderProductData[1].createOrderDeliverySlotData[{{j}}].quantity"
                                                                        (keyup)="handledelvierynan($event,j,k)" /><span
                                                                        class="glyphicon form-control-erroricon"
                                                                        [ngClass]="productinput2.producterrorMsg ? 'glyphicon-exclamation-sign' : ''"></span>
                                                                </td>
                                                            }

                                                        </ng-container>

                                                        <td class="gapdose"></td>
                                                        <td class="deliveryallocated_input dosesbox"
                                                            [ngClass]="product.allocatederrorMsg ? 'has-error' : ''">
                                                            <input type="text" autocomplete="off"
                                                                class="  delivery_data qivcallocated form-control dynallacted"
                                                                id="qivcallocated[0]" value=""
                                                                [(ngModel)]="product.allocatedvalue"
                                                                name="deliveryweek.qivcallocated[0]" readonly /><span
                                                                class="glyphicon form-control-erroricon"
                                                                [ngClass]="product.allocatederrorMsg ? 'glyphicon-exclamation-sign' : ''"></span>
                                                        </td>
                                                        <td class="deliverydate_input dosesbox "><input type="text"
                                                                autocomplete="off"
                                                                class=" delivery_data qivctotal form-control"
                                                                id="qivctotal[0]"
                                                                [value]="numberWithCommas(product.qty)" readonly /></td>
                                                       <!--  <td class="greentick"
                                                            [ngClass]="product.matchtick? 'matchtick':''">
                                                        </td> -->
                                                    </tr>
                                                    <tr class="qivcyear">
                                                      
                     
                                                       <!--  <td class="deliverycol1"></td> -->
                                                       @if(editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials.length>1){
                                                        <td [attr.colspan]="editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials[1].deliverySlots?.length" class="errorarea">
                                                            @if(editdeliverydata.deliverySlotResponseData.shippingLocations[0]?.locationsumerror){
                                                                <div class="totalcheck"
                                                                    >
                                                                    {{"startorderUk.deliveryweek.doseserrormsg" |
                                                                    cxTranslate}}</div>
                                                                }
                                                               
                                                                <div class="allocatedcheck">
                                                                    @if(editdeliverydata.deliverySlotResponseData.shippingLocations[0]?.locationlevelerror){
                                                                    {{editdeliverydata.deliverySlotResponseData.shippingLocations[0]?.locationmsg}}}
                                                                </div>
                                                            </td>
                                                        }@else{
                                                            <td [attr.colspan]="editdeliverydata.deliverySlotResponseData.shippingLocations[0].materials[0].deliverySlots?.length" class="errorarea">
                                                                @if(editdeliverydata.deliverySlotResponseData.shippingLocations[0]?.locationsumerror){
                                                                    <div class="totalcheck"
                                                                        >
                                                                        {{"startorderUk.deliveryweek.doseserrormsg" |
                                                                        cxTranslate}}</div>
                                                                    }
                                                                   
                                                                    <div class="allocatedcheck">
                                                                        @if(editdeliverydata.deliverySlotResponseData.shippingLocations[0]?.locationlevelerror){
                                                                        {{editdeliverydata.deliverySlotResponseData.shippingLocations[0]?.locationmsg}}}
                                                                    </div>
                                                                </td>

                                                        }
                                                           
                                                        <td></td>
                                                        <td></td>
                                                        <td  class="totalvat">
                                                            Total (ex VAT)
        
                                                        </td>
                                                        <td  class="totalcostdelivery">
                                                            <input autocomplete="off"
                                                                class=" delivery_data qivctotal form-control "  name="deliveryweek.qivctotalcost"
                                                                id="qivctotalcost" [(ngModel)]="product.totalcosteach" value=""
                                                                readonly />
        
                                                        </td>
                                                    </tr>

                                               }



                                            }




                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="totalcostbox">
                         
                                <div class="totalcostex totolinput">Total Cost (ex VAT)</div>
                                <div class="totalcostdelivery totolinput">
                                    <input autocomplete="off"
                                    name="locationspecifictotalcost"
                                        class=" delivery_data qivctotal form-control "
                                        [value]="editdeliverydata.deliverySlotResponseData.shippingLocations[0].totalcost | currency:'GBP':'symbol':'1.2-2'"
                                        id="qivctotalcost" 
                                        readonly />
    
                                </div>
                            </div>
                        </div>
                        <div>

                        </div>
                    </form>
                </div>
            </div>
            <!-- bottom section Review buttom -->
            <div class="deliveryReview_but margin-B30">
                <div class="bot_section">
                    
                    <a class="OM_exitBtn showPopupclick  margin-R30" 
                        (click)="handleOnExitClick()" data-toggle="modal"
                        data-target="#OM_exitPopup">{{"startorderUk.productpage.exitlabel" | cxTranslate}}</a>
                    
                    <button class="select_review" id="editReviewOrder"
                        [ngClass]="disabledelivery==false?'reviewbtn_disable':''"
                        (click)="handleOnReviewOrderBtnClick()">{{"startorderUk.deliveryweek.reviewamendorder" |
                        cxTranslate}}</button>
                </div>
            </div>
        </div>
    </section>

</div>
 }



<div class="OM_removePop modal" id="cart_removemodal" role="dialog" data-keyboard="false" tabindex="-1">

    <div class="modal-dialog">

        <div class="modal-content">

            <div class="OM_externalPopContent modal-body">
                <div class="OM_externalPopHeader">
                    <div class="OM_externalPopTitle">{{"startorderUk.removeallDosespopup.title" | cxTranslate}}</div>
                    <div class="OM_removePopClose" data-bs-dismiss="modal">X</div>
                    <div class="clearboth"></div>
                </div>
                <div class="OM_externalPopText">
                    <p>{{"startorderUk.removeallDosespopup.message" | cxTranslate}}</p>
                </div>
                <div class="OM_externalPopBtns">
                    <button class="OM_externalPopBtn OM_removePopRemoveBtn" (click)="handleOnRemoveDoses()"
                        data-bs-dismiss="modal">{{"startorderUk.productpage.removealldoses" | cxTranslate}}</button>
                    <button class="OM_externalPopBtn OM_removePopExitBtn"
                        data-bs-dismiss="modal">{{"startorderUk.removeallDosespopup.gobacklabel" |
                        cxTranslate}}</button>
                </div>
            </div>
        </div>
    </div>

</div>
@if(showExitPopUp){
<div id="OM_exitPopup" class="modal fade in show" role="dialog" data-keyboard="false" tabindex="-1"
    >
    <div class="modal-dialog">

        <div class="modal-content">
            <div class="modal-body">
                <h4 class="modal-title OMexit_popHeader col-xs-9">{{"startorderUk.exitpopup.title" | cxTranslate}}</h4>
                <div class="col-xs-3">
                    <span class="OMexit_popClose" data-bs-dismiss="modal" (click)="handleOnCloseButton()">×</span>
                </div>
                <div class="exitcontent">{{"startorderUk.exitpopup.message2" | cxTranslate}}</div>
                <div class="clearboth"></div>
                <div class="OM_exitPopBtnParent">
                    <button class="OM_popExitBtn"
                        (click)="handleOnExitBtnClick()">{{"startorderUk.exitpopup.exitnloselabel" |
                        cxTranslate}}</button>
                    <button class="OM_popBackBtn" data-bs-dismiss="modal"
                        (click)="handleOnCloseButton()">{{"startorderUk.exitpopup.gobacklabel" | cxTranslate}}</button>
                </div>
            </div>

        </div>
    </div>
</div>
}
@if(amendapifailure){
<div id="apifailurepopup" class="modal fade in show" role="dialog" data-backdrop="static" data-keyboard="false"
    tabindex="-1" >

    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="col-xs-12 returnopenheader">
                    <h4 class="modal-title return_popHeader col-xs-9 no-padding">{{"startorderUk.apifailurepopup.title"
                        | cxTranslate}}</h4>
                    <div class="col-xs-3 no-padding">
                        <!-- <span class="OMexit_popClose" data-dismiss="modal">&times;</span>  -->
                    </div>
                </div>
                <p class="returnpopupsub col-xs-12 margin-T20">{{"startorderUk.apifailurepopup.message" | cxTranslate}}
                </p>
                <div class="clearboth"></div>

                <div class="OM_exitPopBtnParent">
                    <button class="returnbtn"><a class="exitSkipBtn"
                            [routerLink]="['/my-account']">{{"startorderUk.apifailurepopup.returntodashbaord" |
                            cxTranslate}}</a></button>
                </div>
                <div class="clearboth"></div>
                <div class="returnpopupjobcode">{{"startorderUk.apifailurepopup.jobbagcode" | cxTranslate}}</div>
            </div>
        </div>
    </div>
</div>
}